import { render, staticRenderFns } from "./drkshop.vue?vue&type=template&id=f5c6c870&"
import script from "./drkshop.vue?vue&type=script&lang=js&"
export * from "./drkshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports